function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import classnames from "classnames";
import TabsComponent from "components/core/tabs/tabs-component";
import TabComponent from "components/core/tabs/tab/tab-component";
import AssetComponent from "components/core/asset/asset-component";
import Title from "segments/desktop/core-components/title/title";
import { StyledProcessTabsDesktop } from "./process-tabs-desktop.scss";
const ProcessTabsDesktop = ({ tabs, tabsColor, activeTabId, distanceFromTop, autoTransition, scrollSpeed, scrollOnTabClick, showProcessIndicator, titleConfig })=>{
    const [isAutoTransition, setIsAutoTransition] = useState(true);
    const renderedTabs = useMemo(()=>{
        return tabs.map((tab, index)=>{
            const { tabLabel, tabId, asset, title } = tab;
            return /*#__PURE__*/ _jsx(TabComponent, {
                tabClassName: classnames("process-tab", {
                    "process-indicator": showProcessIndicator
                }),
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "asset-and-text",
                    children: [
                        asset && /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset)),
                        title && /*#__PURE__*/ _jsx(Title, _object_spread({
                            titleClassName: "asset-title"
                        }, title, titleConfig))
                    ]
                })
            }, index);
        });
    }, [
        showProcessIndicator,
        tabs,
        tabsColor,
        titleConfig
    ]);
    return /*#__PURE__*/ _jsx(StyledProcessTabsDesktop, {
        className: "process-tabs-desktop",
        onMouseLeave: ()=>setIsAutoTransition(true),
        onMouseEnter: ()=>setIsAutoTransition(false),
        children: /*#__PURE__*/ _jsx(TabsComponent, {
            autoTransition: isAutoTransition ? autoTransition : null,
            scrollOnTabClick: scrollOnTabClick,
            scrollSpeed: scrollSpeed,
            distanceFromTop: distanceFromTop,
            activeTabId: activeTabId,
            role: "tabpanel",
            children: renderedTabs
        })
    });
};
export default ProcessTabsDesktop;
